export default "__VITE_ASSET__CPPC6le0__"